import React from 'react';
import { IIcon } from '../../@types/icons';
import { defaultTheme } from './../../styles/theme/default';

export function ChevronRight ({ size = 12, strokeColor = 'oxfordBlue' }: IIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 12 12"
    >
      <path
        stroke={defaultTheme.colors[strokeColor]}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m4.5 11 4.9-4.764a.326.326 0 0 0 0-.471L4.5 1"
      />
    </svg>
  );
}
